// extracted by mini-css-extract-plugin
export default {"form-actions":"BookingForm_form-actions__0+wZq","wrong-input":"BookingForm_wrong-input__7VDhy"};